import React, { Component } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import AppContext from '../contexts/AppContext';
import ThreeCanvas from '../components/Webgl/ThreeCanvas';
import EditLayer from '../components/UI/EditLayer';
import { SceneProvider } from '../contexts/SceneContext';
import MainBottomNav from '../components/UI/nav/MainBottomNav';
import ArtworkBottomInfo from '../components/UI/ArtworkBottomInfo';
import TopDebugNav from '../components/UI/nav/TopDebugNav';
import IntroLayer from '../components/UI/introduction/IntroLayer';
import ModalTutorial from '../components/UI/modals/ModalTutorial';
import ConfirmQuitModal from '../components/UI/modals/ConfirmQuitModal';
import PlaceNameLayer from '../components/UI/PlaceNameLayer';
import BtsMemberGuidePicture from '../components/UI/BtsMemberGuidePicture';
import About from '../components/UI/About';
import ArtworksList from '../components/UI/ArtworksList';
import PanoLoader from '../utils/PanoLoader';
import Preloader from '../components/UI/Preloader';
import { setSearchParam, getUrlVars } from '../utils/URLUtils';
import Axl from '../utils/Axl';
import selectedJsonEn from '../data/selected.json';
import selectedJsonEs from '../data/selected_es.json';
import selectedJsonKr from '../data/selected_kr.json';
import selectedJsonJp from '../data/selected_jp.json';
import selectedJsonZhTw from '../data/selected_zh-tw.json';
import './Scene.css';

const BTS_GALLERIES_DATA = {
  en: selectedJsonEn,
  es: selectedJsonEs,
  kr: selectedJsonKr,
  KO: selectedJsonKr,
  ko: selectedJsonKr,
  jp: selectedJsonJp,
  ja: selectedJsonJp,
  zh: selectedJsonZhTw,
  tw: selectedJsonZhTw,
  'zh-tw': selectedJsonZhTw,
  'zh-TW': selectedJsonZhTw,
};

const INTRO_BTS_MESSAGE_ID = 'intro';

class Scene extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    const { lang, params } = props;

    this.selectedJson =
      lang in BTS_GALLERIES_DATA
        ? BTS_GALLERIES_DATA[lang]
        : BTS_GALLERIES_DATA.en;

    this.state = {};

    this.hintTimeout = null;

    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.closeBtsMemberMessage = this.closeBtsMemberMessage.bind(this);
    this.unfocusArtwork = this.unfocusArtwork.bind(this);
    this.onAboutClick = this.onAboutClick.bind(this);
    this.onHomeClick = this.onHomeClick.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);

    this.state.isLoadingTiles = false; // only for tiles
    this.state.isAppLoaded = false;
    this.state.isAppReady = false;
    this.state.isAppAxlStarted = false;

    this.state.google = null;
    this.state.map = null;
    this.state.panorama = null;
    this.state.location = { lat: 0, lng: 0 };
    this.state.pano = '';
    this.state.currentLocation = null;
    this.state.selectedItem = null;

    // ------ ux

    this.state.showAbout = false;
    this.state.showBottomUx = false;
    this.state.showDownloadJson =
      params && (params.dljson === true || 'editData' in params);
    this.state.showLoader = true;
    this.state.showIntro = true;
    this.state.showEditArtworks = false;
    this.state.showMenu = false;
    this.state.assetIdForBtsMemberGuide = '';

    this.state.tutorialModalOpen = false;
    this.state.confirmModalOpen = false;

    this.state.addArtworkEnabled = true;
    this.state.isShowingBottomNavHint = false;

    this.state.loadedGallery = null;
    this.state.loadedArtworks = null;
    this.galleryToLoad = null; // will load this in scene after tiles loaded
    this.homeGallery = null;

    this.webGLCanvas = null;

    this.scale =
      this.urlVars && this.urlVars.scale
        ? this.urlVars.scale
        : isMobile
        ? 1.0
        : 1.0;

    this.webGLCanvas = new ThreeCanvas();
    this.panoLoader = new PanoLoader();

    // data
    this.state.gacImagesJson = null;
    this.state.gacImagesThemes = null;
    this.state.locationsJson = null;
    this.state.showBottomUxDelete = true;
    this.state.gyroEnabled = false;

    this.hasOpenedTutorial = false;
    this.hasUserStarted = false;
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    this.webGLCanvas.stop();
    this.webGLCanvas.destroyContext();
  }

  // ------------------------------------------------------------------------

  startIntroDescription() {
    this.hasUserStarted = true;
    this.launchApp();
  }

  sendTrackEvent(action, label, value) {
    if (this.context.axl) {
      this.context.axl.sendMessage(Axl.ChildToHost.TRACK, {
        action,
        label,
        value,
      });
    }
  }

  share(prevDictionaryKey = 'share-prev', endDictionaryKey = 'share-end') {
    const { currentLocation, loadedGallery } = this.state;
    const { axl, dictionnary } = this.context;
    let sharePrevText = dictionnary.get(prevDictionaryKey);
    sharePrevText = sharePrevText.replace('<location>', currentLocation.name);
    sharePrevText = sharePrevText.replace('<city>', currentLocation.city);
    sharePrevText = sharePrevText.replace('<city name>', currentLocation.city);
    if (loadedGallery && loadedGallery.meta) {
      sharePrevText = sharePrevText.replace(
        '<band member name>',
        loadedGallery.meta.member,
      );
    }
    const shareEndText = dictionnary.get(endDictionaryKey);
    const shareTxt = `${sharePrevText}. ${shareEndText}`;
    // const imageType = 'image/png';
    // const imageData = this.webGLCanvas.renderer.domElement.toDataURL(imageType);
    axl.sendMessage(Axl.ChildToHost.SHARE, {
      title: shareTxt,
      /*
      files: [
        {
          data: imageData,
          name: `bts-street-gallery-${currentLocation.city}.${imageType.replace(
            'image/',
            '',
          )}`,
          type: imageType,
        },
      ],
      */
    });
  }

  isAppReady() {
    return (
      !this.state.isLoadingTiles &&
      this.state.gacImagesJson &&
      this.state.locationsJson
    );
  }

  isAppStarted() {
    return (
      !this.state.isLoadingTiles &&
      this.state.gacImagesJson &&
      this.state.locationsJson &&
      this.hasUserStarted
    );
  }

  setCurrentLocationFromPano() {
    const ctx = this.context;
    const currentLocation = ctx.locManager.getByPanoId(this.state.pano);
    if (currentLocation) {
      this.setState({
        currentLocation,
      });
    }
  }

  //------------------------------------------------------

  loadTiles() {
    const { pano, loadedGallery } = this.state;
    if (!pano) return;

    this.setState({
      showLoader: true,
      isLoadingTiles: true,
    });

    this.panoLoader.getMetadata(pano, (data) => {
      this.panoLoader.loadPanorama(pano);
      this.webGLCanvas.addPanoSphere();

      this.webGLCanvas.setUrlAsTexture(this.panoLoader.getUrl(pano), () => {
        const hasParams = loadedGallery && loadedGallery.camParams;

        if (hasParams) {
          this.webGLCanvas.defaultHeading = loadedGallery.camParams.lon;
          this.webGLCanvas.defaultPitch = loadedGallery.camParams.lat;
        } else {
          this.webGLCanvas.defaultHeading = this.loadedPano.heading - 180; // 90 + this.loadedPano.heading;
          this.webGLCanvas.defaultPitch = -this.loadedPano.pitch;
        }
        this.onLoadTilesComplete();

        const needTilt = true;

        if (needTilt) {
          this.webGLCanvas.orientHeading(
            data.Orientation.heading,
            data.Orientation.pitch,
            data.Orientation.roll,
          );

        } else {
          this.webGLCanvas.orientHeading(180 * (Math.PI / 180), 0, 0);
        }
      });
    });
    this.setCurrentLocationFromPano();
  }

  async loadGalleryData(gallery, showOnLoad = false) {
    // load
    await this.webGLCanvas.drawManager.load(gallery, showOnLoad);
    this.loadArtworkList();
  }

  loadArtworkList() {
    // get list of artworks
    const list = this.webGLCanvas.drawManager.imageManager.getPlanesIdList();
    const db = this.context;
    const loadedArtworks = db.dsManager.getItemsByIds(list);
    this.setState({ loadedArtworks });
  }

  //------------------------------------------------------

  showArtworkInfo(newSelectedItem) {
    const { selectedItem, loadedGallery, currentLocation } = this.state;
    const hasChanged =
      newSelectedItem &&
      (!selectedItem || selectedItem.asset_id !== newSelectedItem.asset_id);

    if (hasChanged) {
      const location = currentLocation
        ? `${currentLocation.city}-${currentLocation.name}`
        : '';
      this.sendTrackEvent(
        `focus-artwork-${newSelectedItem.asset_id}`,
        loadedGallery && loadedGallery.meta ? loadedGallery.meta.id : location,
      );
    }
    this.setState({
      showBottomUx: !!newSelectedItem,
      selectedItem: newSelectedItem,
    });
  }

  setupScene(ctx) {
    this.webGLCanvas.db = ctx.dbManager;
    this.webGLCanvas.setupScene(this.container);

    const datasetManager = this.context.dsManager;

    this.webGLCanvas.on('mousedown', (result) => {
      // only in edition mode
      if (this.webGLCanvas.drawManager.enableMouse) {
        let selectedItem = null;
        if (this.webGLCanvas.hasClickedObject) {
          const selectedObject =
            this.webGLCanvas.drawManager.imageManager.selectedImage ||
            this.webGLCanvas.drawManager.imageManager.selectedAnchor.parent;

          if (selectedObject) {
            const selectedID = selectedObject.userData.itemId;
            selectedItem = datasetManager.getItemById(selectedID);
          }
        }

        this.showArtworkInfo(selectedItem);
      }
    });

    this.webGLCanvas.on('focus', (result) => {
      const selectedID = result.userData.itemId;
      const selectedItem = datasetManager.getItemById(selectedID);
      this.showArtworkInfo(selectedItem);

      this.setState({
        showBottomUxDelete: false,
        assetIdForBtsMemberGuide: selectedID,
      });
    });

    this.webGLCanvas.on('focus-end', () => {
      this.setState({
        showBottomUx: false,
        showBottomUxDelete: true,
        selectedItem: null,
        assetIdForBtsMemberGuide: '',
      });
    });

    this.webGLCanvas.on('orientation', (enabled) => {
      this.setState({
        gyroEnabled: this.webGLCanvas.orientationIsEnabled,
      });
    });

    this.webGLCanvas.drawManager.on('push-history', (data) => {
      this.setState({
        addArtworkEnabled: data.nPlanes < 30,
      });
    });
  }

  // ------------------------------------------------------  UI events

  onOpacityHandler(val) {
    this.webGLCanvas.drawManager.imageManager.setOpacity(val);
  }

  onDeleteIconHandler(val) {
    if (this.webGLCanvas.drawManager.imageManager.deleteSelected()) {
      this.webGLCanvas.drawManager.pushHistory();
      this.webGLCanvas.hasClickedObject = false;
      this.setState({
        showBottomUx: this.webGLCanvas.hasClickedObject,
        selectedItem: null,
      });
    }
  }

  // ------------------------------------------------------  listeners

  resetCommonStates() {
    this.setState({
      showBottomUx: false,
      assetIdForBtsMemberGuide: '',
    });
  }

  setEditView() {
    const { loadedGallery } = this.state;

    this.webGLCanvas.drawManager.imageManager.clearSelected();
    const hasLoadedGallery = !!loadedGallery;
    this.webGLCanvas.drawManager.enableMouse = hasLoadedGallery;

    this.resetCommonStates();
    this.setState({
      showBottomUxDelete: hasLoadedGallery,
    });
  }

  loadAssets() {
    const db = this.context;
    db.dsManager.loadCsvList(() => {
      this.setState(
        {
          gacImagesJson: db.dsManager.data,
          gacImagesThemes: db.dsManager.themes,
        },
        this.launchApp(),
      );
    });

    db.locManager.loadCsv(() => {
      this.setState(
        {
          locationsJson: db.locManager.data,
        },
        () => {
          this.launchApp();
        },
      );
    });
  }

  loadDefaultGallery() {
    const { params } = this.props;
    let selected =
      this.selectedJson[
        Math.round(Math.random() * (this.selectedJson.length - 1))
      ];

    if (params && params.defaultId) {
      const results = this.selectedJson.filter((entry) => {
        return params.defaultId && entry.id === params.defaultId;
      });

      if (results.length) {
        selected = results[0];
      }
    }
    this.sendTrackEvent('view-inspire', selected.id);
    const url = `street-gallery-bts/assets/curated/${selected.id}.json`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        data.default = true;
        data.meta = selected;
        this.homeGallery = data;
        this.galleryToLoad = data;
        this.setState(
          {
            loadedGallery: data,
            location: data.location,
            pano: data.pano,
            showIntro: true,
            addArtworkEnabled: true,
          },
          () => {
            this.loadTiles();
            this.setCurrentLocationFromPano();
          },
        );

        setSearchParam('id', null);
      });
  }

  unfocusArtwork() {
    if (this.webGLCanvas && this.webGLCanvas.isFocus) {
      this.webGLCanvas.drawManager.imageManager.unfocusImage();
    }
  }

  init() {
    // setup webgl scene and sent to context
    const ctx = this.context;
    // axl start
    if (ctx.axl) {
      ctx.axl.registerMessageCallback(Axl.HostToChild.RESUME, () => {
        this.setState({ isAppAxlStarted: true });
        if (this.webGLCanvas.isFocus) {
          this.webGLCanvas.drawManager.imageManager.unfocusImage();
        }
      });
    } else {
      this.setState({ isAppAxlStarted: true });
    }

    this.setupScene(ctx);
    ctx.three = this.webGLCanvas;

    this.loadAssets();

    let id = null;
    if (ctx.axl && this.props.params) {
      id = this.props.params.id;
    } else {
      const vars = getUrlVars();
      id = vars.id;
    }

    if (ctx.axl && this.props.params && 'editData' in this.props.params) {
      const customData = this.props.params.editData;
      const editMode = true;
      this.webGLCanvas.autoRotate = true;
      this.webGLCanvas.drawManager.enableMouse = editMode;
      const state = {
        showIntro: true,
        loadedGallery: customData,
        location: customData.location,
        pano: customData.pano,
        addArtworkEnabled: true,
      };

      this.setState(state, () => {
        this.loadTiles();
      });
      this.galleryToLoad = customData;
      this.homeGallery = customData;
    } else if (!id) {
      this.loadDefaultGallery();
    } else {
      // is is a new
      ctx.dbManager.get(
        id,
        (result) => {
          if (result && result.data) {
            const editMode = false;
            this.webGLCanvas.autoRotate = true;
            this.webGLCanvas.drawManager.enableMouse = editMode;
            const state = {
              showIntro: true,
              loadedGallery: result,
              location: result.location,
              pano: result.pano,
              addArtworkEnabled: true,
            };

            this.setState(state, () => {
              this.loadTiles();
            });
            this.galleryToLoad = result;
            this.homeGallery = result;
          } else {
            this.loadDefaultGallery();
          }
        },
        () => {
          this.loadDefaultGallery();
        },
      );
    }

    window.addEventListener('resize', this.handleWindowResize, false);

    const mql = window.matchMedia('(orientation: portrait)');
    mql.addListener(this.unfocusArtwork);
    window.addEventListener('orientationchange', this.unfocusArtwork);
  }

  createNewPanorama() {
    setSearchParam('id', null);

    this.webGLCanvas.drawManager.reset();
    this.webGLCanvas.drawManager.enableMouse = true;
    this.webGLCanvas.autoRotate = false;
    this.setCurrentLocationFromPano();
    this.setState({
      loadedGallery: null,
    });

    if (this.state.isAppLoaded) {
      this.setState({
        tutorialModalOpen: true,
      });

      this.hasOpenedTutorial = true;
    }
  }

  launchApp() {
    this.setCurrentLocationFromPano();

    if (this.isAppReady()) {
      this.setState({
        isAppReady: true,
        showLoader: false,
      });
    }

    if (this.isAppStarted() && !this.state.isAppLoaded) {
      this.introZoom();
    }
  }

  checkLeavingStatus(handler) {
    if (!this.state.loadedGallery) {
      this.setState({
        confirmModalOpen: true,
      });
      this.onConfirmModalHandler = handler;
    } else {
      handler();
    }
  }

  onInspireMeClickHandler(result) {
    this.sendTrackEvent('view-inspire', result.id);
    setSearchParam('id', null);

    this.loadedPano = result;
    this.webGLCanvas.drawManager.reset();
    this.webGLCanvas.prepareForLoading();
    this.webGLCanvas.autoRotate = false;
    this.webGLCanvas.drawManager.enableMouse = false;

    fetch('street-gallery-bts/assets/curated/' + result.id + '.json')
      .then((response) => response.json())
      .then((data) => {
        data.default = true;
        data.meta = result;
        data.notTilted = result.isTilted ? false : true;

        this.galleryToLoad = data;

        this.resetCommonStates();
        this.setState(
          {
            loadedGallery: data,
            location: data.location,
            pano: data.pano,
            currentLocation: this.loadedPano,
            addArtworkEnabled: true,
            showMenu: false,
            //assetIdForBtsMemberGuide: INTRO_BTS_MESSAGE_ID,
          },
          () => {
            this.loadTiles();
            // show intro bts message
            setTimeout(() => {
              if (this.state.assetIdForBtsMemberGuide === '') {
                this.setState({
                  assetIdForBtsMemberGuide: INTRO_BTS_MESSAGE_ID,
                });
              }
            }, 600);
          },
        );
      });
  }

  onCityClickHandler(result) {
    this.loadedPano = result;
    setSearchParam('id', null);
    this.webGLCanvas.drawManager.reset();
    this.galleryToLoad = null;
    this.webGLCanvas.prepareForLoading();
    this.webGLCanvas.drawManager.enableMouse = true;
    this.webGLCanvas.autoRotate = false;
    this.resetCommonStates();
    this.setState(
      {
        pano: result.panoid,
        currentLocation: result,
        loadedGallery: null,
        showMenu: false,
      },
      () => {
        this.loadTiles();
      },
    );

    if (this.state.isAppLoaded) {
      this.setState({
        tutorialModalOpen: !this.hasOpenedTutorial,
      });

      this.hasOpenedTutorial = true;
    }
  }

  // TODO clean this
  onArtworkListItemHandler(item) {
    const id = item.asset_id;
    const object =
      this.webGLCanvas.drawManager.imageManager.getPlaneForAssetId(id);
    this.sendTrackEvent('artwork-selection', id);

    if (object) {
      this.webGLCanvas.useFixedCamTarget = true;
      this.webGLCanvas.cameraTarget.x = object.geometry.boundingSphere.center.x;
      this.webGLCanvas.cameraTarget.y = object.geometry.boundingSphere.center.y;
      this.webGLCanvas.cameraTarget.z = object.geometry.boundingSphere.center.z;
      const latlon = this.webGLCanvas.vector3toLonLat(
        this.webGLCanvas.cameraTarget,
      );
      this.webGLCanvas.useFixedCamTarget = false;
      this.webGLCanvas.lon = latlon[0];
      this.webGLCanvas.lat = latlon[1];
    }
    this.setState({
      assetIdForBtsMemberGuide: id,
    });
  }

  onGyroHandler() {
    this.webGLCanvas.initDeviceOrientation();
  }

  onAboutClick() {
    this.setState(prevState => ({
      showAbout: !prevState.showAbout,
    }));
  }

  onMenuClick() {
    clearTimeout(this.hintTimeout);
    this.setState({ isShowingBottomNavHint: false });
    this.setState((prevState) => ({
      showMenu: !prevState.showMenu,
    }));
  }

  onOverlayClick() {
    if(this.state.showAbout) {
      this.onAboutClick();
    }
    if(this.state.showMenu) {
      this.onMenuClick();
    }
  }

  onHomeClick() {
    if (this.homeGallery) {
      this.sendTrackEvent('back-home', this.homeGallery.id);
      setSearchParam('id', null);

      this.checkLeavingStatus(() => {
        this.webGLCanvas.drawManager.reset();
        this.webGLCanvas.prepareForLoading();
        this.webGLCanvas.autoRotate = false;
        this.webGLCanvas.drawManager.enableMouse = false;

        this.galleryToLoad = this.homeGallery;

        this.resetCommonStates();
        const ctx = this.context;
        const currentLocation = ctx.locManager.getByPanoId(
          this.homeGallery.pano,
        );
        this.setState(
          {
            loadedGallery: this.homeGallery,
            location: this.homeGallery.location,
            pano: this.homeGallery.pano,
            currentLocation,
            addArtworkEnabled: true,
          },
          () => {
            this.loadTiles();
            // show intro bts message
            setTimeout(() => {
              if (this.state.assetIdForBtsMemberGuide === '') {
                this.setState({
                  assetIdForBtsMemberGuide: INTRO_BTS_MESSAGE_ID,
                });
              }
            }, 600);
          },
        );
      });
    }
  }

  // ------------------------------------------------------  visibility

  gyroLayerVisible() {
    return false;
  }

  isEditLayerVisible() {
    const { loadedGallery, isAppLoaded } = this.state;
    return !loadedGallery && isAppLoaded && !isMobile && !isTablet;
  }

  handleWindowResize() {
    this.webGLCanvas.handleWindowResize();
  }

  onGallerySaved(id) {
    if (this.context.axl) {
      this.context.axl.sendMessage(Axl.ChildToHost.SET_URL_PARAMS, { id: id });
      this.share();
      this.setState({
        showLoader: false,
      });
    } else {
      setSearchParam('id', id);
      this.setState({
        currentUrl: window.location.href,
        showLoader: false,
      });
    }
  }

  introZoom(delay = 0.25) {
    const { isAppLoaded, assetIdForBtsMemberGuide } = this.state;
    const { params } = this.props;
    this.webGLCanvas.zoomToCenter(
      0,
      2,
      delay,
      () => {
        if (this.galleryToLoad) {
          this.loadGalleryData(this.galleryToLoad, true);
          this.galleryToLoad = null;
        }
        if (!isAppLoaded) {
          this.sendTrackEvent('app-launch');
          this.hintTimeout = setTimeout(() => {
            this.setState({ isShowingBottomNavHint: true });
          }, 25 * 1000); // 25 seconds
        }
        this.setState({ isAppLoaded: true });

        // Start on edition
        if (params && ('editData' in params || params.allowEdit)) {
          this.setEditView();
          this.setState(
            {
              addArtworkEnabled: true,
              loadedGallery: null,
            },
            () => {
              this.webGLCanvas.drawManager.enableMouse = true;
            },
          );
        } else {
          // show intro bts message
          setTimeout(() => {
            if (assetIdForBtsMemberGuide === '') {
              this.setState({
                assetIdForBtsMemberGuide: INTRO_BTS_MESSAGE_ID,
              });
            }
          }, 600);
        }
      },
      true,
    );
  }

  onLoadTilesComplete() {
    this.setState({
      showLoader: false,
      isLoadingTiles: false,
    });

    // in introduction no need to zoom
    if (this.isAppStarted()) {
      this.introZoom(2);
      if (this.hasOpenedTutorial && !this.state.loadedGallery) {
        this.setState({
          showEditArtworks: true,
        });
      }
    } else {
      // try to unlock app
      this.launchApp();
    }
  }

  onDownloadButtonHandler() {
    const { currentLocation, pano } = this.state;
    const filename = 'gallery.json';
    const { data, camParams } = this.webGLCanvas.getGalleryState();

    const fullData = JSON.stringify(
      {
        active: false,
        location: currentLocation,
        pano,
        data,
        camParams,
      },
      undefined,
      4,
    );

    const blob = new Blob([fullData], { type: 'text/json' });
    const e = document.createEvent('MouseEvents');
    const a = document.createElement('a');

    a.download = filename;
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
    e.initMouseEvent(
      'click',
      true,
      false,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null,
    );
    a.dispatchEvent(e);
  }

  closeBtsMemberMessage() {
    this.setState({
      assetIdForBtsMemberGuide: '',
    });
  }

  onShareButtonHandler() {
    const { axl, dbManager } = this.context;
    const { loadedGallery, currentLocation, pano } = this.state;
    if (axl && loadedGallery && loadedGallery.default) {
      // SHARE DEFAULT URL
      axl.sendMessage(Axl.ChildToHost.SET_URL_PARAMS, {
        defaultId: loadedGallery.meta.id,
      });

      this.sendTrackEvent('sharing-inspire', loadedGallery.meta.id);
      this.share('share-prev-inspire');
    } else {
      this.setState({
        showLoader: true,
      });

      const state = this.webGLCanvas.getGalleryState();
      dbManager.save(
        state.data,
        state.camParams,
        pano,
        currentLocation,
        (id) => {
          this.sendTrackEvent('sharing-gallery', id);
          if (!isMobile && !isTablet) {
            this.onGallerySaved(id);
          }
      });
    }
  }

  render() {
    const { dictionnary, locManager } = this.context;
    const {
      isAppLoaded,
      loadedGallery,
      isAppReady,
      isAppAxlStarted,
      currentLocation,
      showAbout,
      showDownloadJson,
      showLoader,
      showMenu,
      loadedArtworks,
      showBottomUx,
      showBottomUxDelete,
      selectedItem,
      confirmModalOpen,
      tutorialModalOpen,
      showEditArtworks,
      addArtworkEnabled,
      gacImagesJson,
      gacImagesThemes,
      currentGalleryID,
      assetIdForBtsMemberGuide,
      isShowingBottomNavHint,
    } = this.state;
    const isEditLayerVisible = this.isEditLayerVisible();
    const { params } = this.props;

    return (
      <>
        <SceneProvider value={{ webgl: this.webGLCanvas }}>
          <IntroLayer
            isAppAxlStarted={isAppAxlStarted}
            isAppReady={isAppReady}
            loadedGallery={loadedGallery}
            isSharedDefault={!!(params && params.defaultId)}
            currentLocation={currentLocation}
            onClickHandler={() => {
              this.startIntroDescription();
            }}
            onEndIntroHandler={() => {
              if (!this.hasUserStarted) {
                this.hasUserStarted = true;
                this.introZoom();
              }
            }}
          />

          <div id="logo" onClick={this.onHomeClick}>
            <img
              src="street-gallery-bts/assets/icons/bts_logo.svg"
              alt="BTS Logo"
            />
          </div>

          <div
            className={`overlay ${
              showAbout || showMenu ? ' overlay--activated' : ''
            }`}
            onClick={this.onOverlayClick}
          />

          {isAppLoaded && (
            <button
              id="about-toggle"
              type="button"
              className="main-button"
              onClick={this.onAboutClick}
            >
              ?
            </button>
          )}

          {showAbout && <About onClose={this.onAboutClick} />}

          {showDownloadJson && (
            <TopDebugNav
              showDownloadJson={showDownloadJson}
              onDownloadClickHandler={() => {
                this.onDownloadButtonHandler();
              }}
            />
          )}

          {!isMobile &&
            !isTablet &&
            !isEditLayerVisible &&
            !showBottomUx &&
            !showAbout && (
              <ArtworksList
                loadedArtworks={loadedArtworks}
                onArtworkListItemHandler={(item) => {
                  this.onArtworkListItemHandler(item);
                }}
                onCloseHandler={() => {
                  this.closeBtsMemberMessage();
                }}
              />
            )}

          {isAppLoaded && (
            <MainBottomNav
              isInEdition={isEditLayerVisible}
              loadedGallery={loadedGallery}
              currentLocation={currentLocation}
              locManager={locManager}
              showMenu={showMenu}
              btsMenuData={this.selectedJson}
              isShowingBottomNavHint={isShowingBottomNavHint}
              onToggleMenu={() => this.onMenuClick()}
              onShareButtonHandler={() => this.onShareButtonHandler()}
              onLocationClickHandler={(result) => {
                this.checkLeavingStatus(() => {
                  this.onInspireMeClickHandler(result);
                });
              }}
              onCityClickHandler={(result) => {
                this.checkLeavingStatus(() => {
                  this.onCityClickHandler(result);
                });
              }}
            />
          )}

          {isAppLoaded &&
            currentLocation &&
            !((isMobile || isTablet) && showBottomUx) && (
              <PlaceNameLayer currentLocation={currentLocation} />
            )}

          {isAppLoaded &&
            loadedGallery &&
            'meta' in loadedGallery &&
            loadedGallery.meta && (
              <BtsMemberGuidePicture
                loadedGallery={loadedGallery}
                assetId={assetIdForBtsMemberGuide}
                introId={INTRO_BTS_MESSAGE_ID}
                onClose={() => {
                  this.setState({ assetIdForBtsMemberGuide: '' });
                }}
                onPictureClick={() => {
                  // toggle message
                  // this.unfocusArtwork();
                  let id = INTRO_BTS_MESSAGE_ID;
                  if (selectedItem) {
                    id = selectedItem.asset_id;
                  }
                  this.setState({
                    assetIdForBtsMemberGuide: assetIdForBtsMemberGuide.length
                      ? ''
                      : id,
                  });
                }}
              />
          )}

          {isEditLayerVisible && (
            <>
              <EditLayer
                openDefault={showEditArtworks}
                loadedGallery={loadedGallery}
                addArtworkEnabled={addArtworkEnabled}
                currentLocation={currentLocation}
                artworksData={gacImagesJson}
                themes={gacImagesThemes}
                currentGalleryID={currentGalleryID}
                showTrash={!!(showBottomUx && showBottomUxDelete)}
                onDeleteHandler={(val) => this.onDeleteIconHandler(val)}
                onOpenHandler={() => {
                  this.setState({ showEditArtworks: true });
                }}
                onCloseHandler={() => {
                  this.setState({ showEditArtworks: false });
                }}
                onArtworksOpenHandler={() => {
                  this.setState({ showBottomUx: false });
                }}
                // launch buc.js
                onChangeLocationHandler={(result) => {
                  this.onCityClickHandler(result);
                }}
                onShareHandler={() => this.onShareButtonHandler()}
                onAddPictureFromDisk={(file) => {
                  this.loadPictureFromDisk(file);
                }}
                onBackButtonHandler={(handler) => {
                  this.setState({
                    confirmModalOpen: true,
                  });
                  this.onConfirmModalHandler = handler;
                }}
              />

              <ModalTutorial
                open={tutorialModalOpen}
                onCloseHandler={() => {
                  this.setState({
                    tutorialModalOpen: false,
                    showEditArtworks: true,
                  });
                }}
              />
            </>
          )}

          {confirmModalOpen && (
            <ConfirmQuitModal
              open={confirmModalOpen}
              onConfirmationHandler={() => {
                this.setState({ confirmModalOpen: false });
                if (this.onConfirmModalHandler) {
                  this.onConfirmModalHandler();
                }
              }}
              onCancelHandler={() => {
                this.setState({ confirmModalOpen: false });
                this.setEditView();
              }}
            />
          )}

          <div
            id="three-canvas"
            ref={(container) => {
              this.container = container;
            }}
          />

          {showBottomUx && <ArtworkBottomInfo selectedItem={selectedItem} />}

          {showLoader && (
            <Preloader isInIntro={!isAppLoaded && !isEditLayerVisible} />
          )}
        </SceneProvider>
      </>
    );
  }
}

export default withRouter(Scene);